import {
    GET_COPO_BASIC_INFO,
    GET_COPO_BASIC_INFO_FAILURE,
    GET_COPO_BASIC_INFO_SUCCESS,
    SET_COPO_BASIC_INFO_FORM_DATA,
    SET_COPO_GENERAL_DETAILS_DATA,
    RESET_COPO_DATA
} from "./actionTypes";

interface CoPoState {
    loading: boolean;
    error: any;
    autoPopulateData: any;
    basicInfoFormData: {
        mmGst: string;
        mmAddress: string;
        billingAddress: string;
        deliveryAddress: string;
        copoNumber: string;
        copoDate: any;
        sameAsBilling: boolean;
    };
    generalDetailsFormData: {
        gstApply: string;
        gstTypeValue: string;
        gstPerValue: number;
        currency: string;
        po: string;
        deliveryType: string;
        deliveryDateCommon: any;
        contactPerson: string;
        contactNumber: string | number;
        contactEmail: string;
        parts: any[];
        tools: any[];
        paymentTerm: string;
        incoterm: string;
        otherTerms: string;
        copoFile: any;
    };
}

const initialState: CoPoState = {
    loading: false,
    error: null,
    autoPopulateData: null,
    basicInfoFormData: {
        mmGst: "",
        mmAddress: "",
        billingAddress: "",
        deliveryAddress: "",
        copoNumber: "",
        copoDate: null,
        sameAsBilling: false
    },
    generalDetailsFormData: {
        gstApply: "",
        gstTypeValue: "",
        gstPerValue: 0,
        currency: "",
        po: "",
        deliveryType: "",
        deliveryDateCommon: null,
        contactPerson: "",
        contactNumber: "",
        contactEmail: "",
        parts: [],

        tools: [],
        paymentTerm: "",
        incoterm: "",
        otherTerms: "",
        copoFile: null
    }
};

const CoPoReducer = (state = initialState, action: any): CoPoState => {
    switch (action.type) {
        case GET_COPO_BASIC_INFO:
            return { ...state, loading: true };
        case GET_COPO_BASIC_INFO_SUCCESS:
            return {
                ...state,
                loading: false,
                autoPopulateData: action.payload
            };
        case GET_COPO_BASIC_INFO_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case SET_COPO_BASIC_INFO_FORM_DATA:
            return {
                ...state,
                basicInfoFormData: {
                    ...state.basicInfoFormData,
                    ...action.payload
                }
            };
        case SET_COPO_GENERAL_DETAILS_DATA:
            return {
                ...state,
                generalDetailsFormData: {
                    ...state.generalDetailsFormData,
                    ...action.payload
                }
            };
        case RESET_COPO_DATA:
            return {
                ...state,
                basicInfoFormData: initialState.basicInfoFormData,
                generalDetailsFormData: initialState.generalDetailsFormData,
                autoPopulateData: null
            };
        default:
            return state;
    }
};

export default CoPoReducer;
